<template>
  <div id="preview">
    <v-card class="rounded-lg shadow-sm" elevation="6">
      <v-form ref="form1" v-model="valid1" lazy-validation>
        <!-- Header Section -->
        <v-card-title class="d-flex justify-space-between align-center px-6 py-4"
          style="border-bottom: 1px solid #e0e0e0; background: linear-gradient(135deg, #1db954 0%, #158b3e 100%);">
          <div class="d-flex align-center">
            <v-icon large color="white" class="mr-3">mdi-account-plus</v-icon>
            <span class="headline font-weight-bold white--text">{{ editIndex > -1 ? 'Edit Member' : 'Add New Member'
            }}</span>
          </div>
          <div>
            <v-btn icon color="white" @click="resetForm" class="mr-2" title="Refresh/Reset Form" elevation="2">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn icon color="white" @click="closePrompt" title="Close" elevation="2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="pt-6 px-6">
          <div class="d-flex justify-space-between align-center mb-6 px-2 py-3"
            style="background-color: #fce4e4; border-radius: 8px; border-left: 4px solid #f44336;">
            <h6 class="mb-0 text-danger font-weight-medium">
              <v-icon small color="error" class="mr-1 mb-1">mdi-asterisk</v-icon> Indicates required field
            </h6>
            <h6 class="mb-0 text-danger font-weight-medium">
              <v-icon small color="error" class="mr-1 mb-1">mdi-translate</v-icon> Kindly fill the details in English
              only
            </h6>
          </div>

          <v-container class="pa-0">
            <!-- Personal Information -->
            <v-row wrap class="mb-2">
              <v-col cols="12">
                <div class="d-flex align-center mb-2">
                  <v-icon color="#1db954" class="mr-2" size="28">mdi-card-account-details-outline</v-icon>
                  <h3 class="font-weight-bold mb-0" style="color: #2c3e50;">Personal Details</h3>
                </div>
                <v-divider class="mb-4"></v-divider>
              </v-col>

              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> First Name</label>
                <v-text-field v-model="FirstName" :rules="FirstNameRules" required outlined dense
                  prepend-inner-icon="mdi-account" placeholder="Enter first name" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;">Middle Name <small
                    class="grey--text">(Optional)</small></label>
                <v-text-field v-model="MiddleName" :rules="MiddleNameRules" required outlined dense
                  prepend-inner-icon="mdi-account-minus" placeholder="Enter middle name" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;">Last Name <small
                    class="grey--text">(Optional)</small></label>
                <v-text-field v-model="LastName" :rules="LastNameRules" required outlined dense
                  prepend-inner-icon="mdi-account-details" placeholder="Enter last name" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> Gender</label>
                <v-select :reduce="(option) => option.value" :items="GenderOptions" :rules="GenderRules"
                  v-model="Gender" required outlined dense prepend-inner-icon="mdi-gender-male-female"
                  placeholder="Select gender" class="mt-2" background-color="#f8f9fa"></v-select>
              </v-col>
            </v-row>

            <!-- Contact Information -->
            <v-row class="mb-2">
              <v-col cols="12" class="mt-4">
                <div class="d-flex align-center mb-2">
                  <v-icon color="#1db954" class="mr-2" size="28">mdi-phone-in-talk</v-icon>
                  <h3 class="font-weight-bold mb-0" style="color: #2c3e50;">Contact Information</h3>
                </div>
                <v-divider class="mb-4"></v-divider>
              </v-col>

              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> Mobile No</label>
                <v-text-field v-model="MobileNo" :rules="MobileNoRules" type="number" :counter="10"
                  v-mask="'##########'" required outlined dense prepend-inner-icon="mdi-cellphone"
                  placeholder="Enter 10-digit mobile number" class="mt-2" background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> Email Id</label>
                <v-text-field v-model="EmailId" :rules="EmailIdRules" type="email" required outlined dense
                  prepend-inner-icon="mdi-email" placeholder="Enter email address" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
            </v-row>

            <!-- Address Information -->
            <v-row wrap class="mb-2">
              <v-col cols="12" class="mt-4">
                <div class="d-flex align-center mb-2">
                  <v-icon color="#1db954" class="mr-2" size="28">mdi-map-marker-radius</v-icon>
                  <h3 class="font-weight-bold mb-0" style="color: #2c3e50;">Address Details</h3>
                </div>
                <v-divider class="mb-4"></v-divider>
              </v-col>

              <v-col cols="12" md="12" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> Street 1</label>
                <v-text-field v-model="Street1" :rules="Street1Rules" required outlined dense
                  prepend-inner-icon="mdi-home" placeholder="Enter street/door no" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="8" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;">Street 2 <small
                    class="grey--text">(Optional)</small></label>
                <v-text-field v-model="Street2" :rules="Street2Rules" required outlined dense
                  prepend-inner-icon="mdi-home-city" placeholder="Enter street name or landmark" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;">Area <small
                    class="grey--text">(Optional)</small></label>
                <v-text-field v-model="Area" :rules="AreaRules" required outlined dense
                  prepend-inner-icon="mdi-map-marker-outline" placeholder="Enter local area" class="mt-2"
                  background-color="#f8f9fa"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> State</label>
                <v-autocomplete :reduce="(option) => option.value" :loading="StateIdOptionsLoading"
                  :items="StateIdOptions" :rules="StateIdRules" v-model="StateId" required outlined dense
                  prepend-inner-icon="mdi-city-variant" placeholder="Select state" class="mt-2"
                  background-color="#f8f9fa"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> District</label>
                <v-autocomplete :reduce="(option) => option.value" :loading="DistrictIdOptionsLoading"
                  :items="DistrictIdOptions" :rules="DistrictIdRules" v-model="DistrictId" required outlined dense
                  prepend-inner-icon="mdi-map" placeholder="Select district" class="mt-2"
                  background-color="#f8f9fa"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> City</label>
                <v-autocomplete :reduce="(option) => option.value" :loading="CityIdOptionsLoading"
                  :items="CityIdOptions" :rules="CityIdRules" v-model="CityId" required outlined dense
                  prepend-inner-icon="mdi-home-group" placeholder="Select city" class="mt-2"
                  background-color="#f8f9fa"></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4" class="py-1">
                <label class="font-weight-bold text-subtitle-2" style="color: #455a64;"><span
                    class="text-danger">*</span> Pincode</label>
                <v-text-field v-model="Pincode" type="number" :rules="PincodeRules" :counter="6" v-mask="'######'"
                  required outlined dense prepend-inner-icon="mdi-mailbox" placeholder="Enter 6-digit pincode"
                  class="mt-2" background-color="#f8f9fa"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 grey lighten-4 d-flex justify-end">
          <v-btn :disabled="!valid1" @click.prevent="submitForm" :loading="SubmitFlag" elevation="4" large
            color="#1db954" class="font-weight-bold px-8 white--text" style="border-radius: 8px;">
            <v-icon left size="24">mdi-content-save-all</v-icon> {{ editIndex > -1 ? 'Update Member' : 'Save Member' }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageDescription: {
      type: String,
    },
    recordData: {
      type: Object,
      default: () => null
    },
    editIndex: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      rows: [],
      member: {},

      FirstName: "",
      FirstNameRules: [(v) => !!v || "First Name is required"],

      MiddleName: "",
      MiddleNameRules: [],

      LastName: "",
      LastNameRules: [],

      Gender: "",
      GenderRules: [(v) => !!v || "Gender is required"],
      GenderOptions: [
        { value: "", text: "--Select--" },
        { value: 1, text: "Male" },
        { value: 2, text: "Female" },
        { value: 3, text: "Others" },
      ],

      Street1: "",
      Street1Rules: [(v) => !!v || "Street 1 is required"],

      Street2: "",
      Street2Rules: [],

      Pincode: "",
      PincodeRules: [(v) => !!v || "Pincode is required"],

      Area: "",
      AreaRules: [],

      MobileNo: "",
      MobileNoRules: [],

      EmailId: "",
      EmailIdRules: [],

      StateIdRules: [(v) => !!v || "State is required"],
      StateId: "",
      StateIdOptions: [],
      StateIdOptionsLoading: false,

      DistrictIdRules: [(v) => !!v || "District is required"],
      DistrictId: "",
      DistrictIdOptions: [],
      DistrictIdOptionsLoading: false,

      CityIdRules: [(v) => !!v || "City is required"],
      CityId: "",
      CityIdOptions: [],
      CityIdOptionsLoading: false,
    };
  },
  computed: {},
  watch: {
    StateIdOptions: function () {
      console.log("watch StateIdOptions");
      this.LoadingFlag = false;
      this.StateIdOptionsLoading = false;
    },
    StateId: function () {
      console.log("watch StateId");
      if (this.StateId) {
        this.LoadingFlag = true;
        this.DistrictIdOptionsLoading = true;
        this.getDistrictIdOptions(
          "DistrictId",
          "DistrictIdOptions",
          this.StateId
        );
      }
    },
    DistrictIdOptions: function () {
      console.log("watch DistrictIdOptions");
      this.LoadingFlag = false;
      this.DistrictIdOptionsLoading = false;
    },
    DistrictId: function () {
      console.log("watch DistrictId");
      if (this.DistrictId) {
        this.LoadingFlag = true;
        this.CityIdOptionsLoading = true;
        this.getCityIdOptions("CityId", "CityIdOptions", this.DistrictId);
      }
    },
    CityIdOptions: function () {
      console.log("watch CityIdOptions");
      this.LoadingFlag = false;
      this.CityIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      //   this.$refs.ProfilePicture.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideAddRecordPrompt", { member: this.member, index: this.editIndex });
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.StateIdOptionsLoading = true;
      this.getStateIdOptions("StateId", "StateIdOptions");
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    getStateIdOptions(source, destination) {
      console.log("getStateIdOptions called");
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/states/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getDistrictIdOptions(source, destination, StateId) {
      console.log("getDistrictIdOptions called StateId=" + StateId);
      if (source != "" && destination != "" && StateId != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/district/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          StatesCode: StateId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getCityIdOptions(source, destination, DistrictId) {
      console.log("getCityIdOptions called DistrictId=" + DistrictId);
      if (source != "" && destination != "" && DistrictId != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/city/options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          DistrictCode: DistrictId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      //   validate1 = false;

      if (validate1) {
        this.SubmitFlag = true;
        var FirstName = this.FirstName;
        var MiddleName = this.MiddleName;
        var LastName = this.LastName;
        var MemberName = FirstName + " " + MiddleName + " " + LastName;

        // Get City details

        var CityId = this.CityId;
        var CityIndex = this.CityIdOptions.map((e) => e.value).indexOf(CityId);
        console.log("CityId=" + CityId + ", CityIndex=" + CityIndex);
        var CityName = this.CityIdOptions[CityIndex].text;
        console.log("CityName=" + CityName);

        // Get District details

        var DistrictId = this.DistrictId;
        var DistrictIndex = this.DistrictIdOptions.map((e) => e.value).indexOf(
          DistrictId
        );
        console.log(
          "DistrictId=" + DistrictId + ", DistrictIndex=" + DistrictIndex
        );
        var DistrictName = this.DistrictIdOptions[DistrictIndex].text;
        console.log("DistrictName=" + DistrictName);

        // Get State details

        var StateId = this.StateId;
        var StateIndex = this.StateIdOptions.map((e) => e.value).indexOf(
          StateId
        );
        console.log("StateId=" + StateId + ", StateIndex=" + StateIndex);
        var StateName = this.StateIdOptions[StateIndex].text;
        console.log("StateName=" + StateName);

        var Street1 = this.Street1;
        var Street2 = this.Street2;
        var Area = this.Area;
        var Pincode = this.Pincode;
        var Gender = this.Gender;
        var AddressTxt =
          Street1 +
          ", <br/> " +
          Street2 +
          ", <br/>" +
          Area +
          ", " +
          CityName +
          ", <br/>" +
          DistrictName +
          ", <br/>" +
          StateName +
          " - " +
          Pincode;
        this.member = {
          MemberName: MemberName,
          MemberFirstName: FirstName,
          MemberMiddleName: MiddleName,
          MemberLastName: LastName,
          MemberEmail: this.EmailId,
          MemberMobileNo: this.MobileNo,
          MemberStreet1: Street1,
          MemberStreet2: Street2,
          MemberArea: Area,
          MemberAddressTxt: AddressTxt,
          MemberCity: CityId,
          MemberDistrictId: DistrictId,
          MemberStateId: StateId,
          MemberPincode: Pincode,
          MemberFlag: true,
          MemberGender: Gender
        };
        console.log("member=" + JSON.stringify(this.member));
        var output = this.editIndex > -1 ? "Member updated successfully. " : "Member added successfully. ";
        // this.SubmitFlag = false;
        this.resetForm();
        this.closePrompt();
        this.sweetAlert("success", output, true);
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
    if (this.recordData && Object.keys(this.recordData).length > 0) {
      this.FirstName = this.recordData.MemberFirstName || "";
      this.MiddleName = this.recordData.MemberMiddleName || "";
      this.LastName = this.recordData.MemberLastName || "";
      this.Gender = this.recordData.MemberGender || "";
      this.Street1 = this.recordData.MemberStreet1 || "";
      this.Street2 = this.recordData.MemberStreet2 || "";
      this.Area = this.recordData.MemberArea || "";
      this.Pincode = this.recordData.MemberPincode || "";
      this.MobileNo = this.recordData.MemberMobileNo || "";
      this.EmailId = this.recordData.MemberEmail || "";

      this.StateId = this.recordData.MemberStateId || "";
      if (this.StateId) {
        this.getDistrictIdOptions("DistrictId", "DistrictIdOptions", this.StateId);
        setTimeout(() => {
          this.DistrictId = this.recordData.MemberDistrictId || "";
          if (this.DistrictId) {
            this.getCityIdOptions("CityId", "CityIdOptions", this.DistrictId);
            setTimeout(() => {
              this.CityId = this.recordData.MemberCity || "";
            }, 500);
          }
        }, 500);
      }
    } else {
      this.member = {};
    }
  },
};
</script>
